import React from 'react';
import { Route } from 'react-router-dom';
import VisitorLog from '@/pages/frontdesk/VisitorLog';
import PhoneLog from '@/pages/frontdesk/PhoneLog';
import EnquiryList from '@/pages/frontdesk/EnquiryList';
import ComplinList from '@/pages/frontdesk/ComplinList';
import PostalExchange from '@/pages/frontdesk/PostalExchange';
import MeetingSchedule from '@/pages/frontdesk/MeetingSchedule';

export const frontDeskRoutes = (
  <React.Fragment>
    <Route path="frontdesk/visitor-log" element={<VisitorLog />} />
    <Route path="frontdesk/phone-log" element={<PhoneLog />} />
    <Route path="frontdesk/enquiry" element={<EnquiryList />} />
    <Route path="frontdesk/complin" element={<ComplinList />} />
    <Route path="frontdesk/postal" element={<PostalExchange />} />
    <Route path="frontdesk/meeting" element={<MeetingSchedule />} />
  </React.Fragment>
);
